<template>
  <BCard no-body class="w-100">
    <BCardBody class="dashboard-align">
      <div class="float-end">
        <div class="d-flex">
          <div
            class="d-flex justify-content-between align-items-center"
          >
            <a
              :href="`${baseURL}/portfolio-review/my-mutual-funds/summary?tab=family`"
              target="_blank"
              rel="noopener noreferrer"
              v-if="familyPortfolio == 0.0"
              class="btn btn-custom prime_btn ml-3"
              >+add PAN</a
            >
          </div>
        </div>
        <div class="d-flex" v-if="familyPortfolio != 0.0">
          <p class="portfolio-switch">
            {{ dynamicSubtitle }}
          </p>
          <div @click="togglePortfolio" style="cursor: pointer">
            <img
              :src="enabled ? switchImage : familySwitchImage"
              alt="Portfolio Switch"
              class="portfolio-switch-image"
            />
          </div>
        </div>
      </div>
      <div>
        <img class="portfolio-image" :src="portfolioImage" alt="img" />
        <span class="dashboard-heading" style="margin-left: 5px">{{
          portfolioTitle
        }}</span>
      </div>
      <div class="dashboard-oneday">
        <p class="m-1" v-if="this.amount !== '₹ 0' && this.amount !== '0'">
          <span class="fw-bold">{{ this.amount }}</span
          >&nbsp;<span
            class="text-muted"
            style="font-weight: 500"
            v-if="this.value !== ''"
            >1 Day</span
          >&nbsp;<span>{{ value }}</span>
          <span v-if="this.value !== ''"
            ><span
              :class="{
                positive: parseFloat(this.dayChangePer) > 0,
                negative: parseFloat(this.dayChangePer) < 0,
              }"
              > ({{ this.dayChangePer }})</span
            >
          </span>
        </p>
        <p class="m-1" v-else>
          <a 
            :href="portfolioReviewLink" 
            target="_blank"
            class="portfolio-link"
          >
            {{ portfolioReviewText }}
          </a>
        </p>
      </div>
    </BCardBody>
  </BCard>
</template>

<script>
import { mapGetters } from "vuex";
import { parseISO, format } from "date-fns";

export default {
  name: "PortfolioList",
  data() {
    return {
      jsonData: [],
      amountFamily: "0.00",
      amountOwn: "0.00",
      amount: "0.00",
      perDay: "1 Day",
      value: "",
      ownPortfolioValue: "",
      familyPortfolioValue: "",
      familyPortfolio: "0.00",
      dayChangePer: "0.00",
      ownDayChangePer: "0.00",
      familyDayChangePer: "0.00",
      rupeeSymbol: "₹",
      perSymbol: "%",
      portfolioTitle: "My portfolio",
      portfolioSubtitle: "Family portfolio",
      portfolioIcon: require("@/assets/images/portfolio/Clippathgroup.svg"),
      familyfolioIcon: require("@/assets/images/portfolio/Group 235.svg"),
      portfolioImage: require("@/assets/images/portfolio/Clippathgroup.svg"),
      enabled: this.$store.getters.portfolioType === "family",
      baseURL: process.env.VUE_APP_BASE_URL,
      familySwitchImage: require("@/assets/images/portfolio/FamilySwitch.svg"),
      switchImage: require("@/assets/images/portfolio/Switch.svg"),
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters(["userProfile", "myPortfolio", "holdingType"]),
    dynamicSubtitle() {
      return this.windowWidth < 400 ? "Family's" : this.portfolioSubtitle;
    },
    portfolioReviewLink() {
      const baseURL = process.env.VUE_APP_BASE_URL || '';
      if (this.holdingType === 'mutualfunds') {
        return `${baseURL}/portfolio-review/mutual-funds`;
      }
      else if (this.holdingType === 'stocks') {
        return `${baseURL}/portfolio-review/stocks`;
      }
      return `${baseURL}/portfolio-review/`;
    },
    portfolioReviewText() {
      if (this.holdingType === 'mutualfunds') {
        return 'Import Mutual Funds Holdings';
      }
      else if (this.holdingType === 'stocks') {
        return 'Import Stock Holdings';
      }
      
      return 'Import Holdings';
    },
  },
  methods: {
    formatToIndianNumber(num) {
      if (num === null || num === undefined || num === "") return "0";
      const value = parseFloat(num);
      const isNegative = value < 0;
      const absValue = Math.abs(value);
      
      let formatted;
      if (absValue >= 10000000) {
        formatted = (absValue / 10000000).toFixed(2) + "Cr";
      } else if (absValue >= 100000) {
        formatted = (absValue / 100000).toFixed(2) + "L";
      } else if (absValue >= 1000) {
        formatted = (absValue / 1000).toFixed(2) + "K";
      } else {
        formatted = absValue.toFixed(0);
      }
      
      return isNegative ? "-" + formatted : formatted;
    },
    formatToMonth(retrievalDate) {
      const date = parseISO(retrievalDate);
      return format(date, "dd MMM yyyy");
    },
    openPortfolioReview() {
      window.location.href = `${process.env.VUE_APP_BASE_URL}/my-portfolio-review-pro/summary`;
    },
    processPRPData(data) {
      try {
        if (!data || typeof data !== "object") {
          throw new Error("Invalid data format");
        }
        this.jsonData = data;
        this.amountOwn = this.jsonData.ownPortfolio?.totalCurrentValue || 0;
        this.ownPortfolioValue =
          this.jsonData.ownPortfolio?.dayChangeValue === null ||
          this.jsonData.ownPortfolio?.dayChangeValue === "NULL"
            ? ""
            : this.jsonData.ownPortfolio?.dayChangeValue;
        this.ownDayChangePer =
          this.jsonData.ownPortfolio.dayChangePercentage !== null
            ? this.jsonData.ownPortfolio.dayChangePercentage
            : "0.0";
        if (Object.keys(this.jsonData.familyPortfolio).length > 0) {
          this.familyPortfolio = this.jsonData.familyPortfolio;
          this.amountFamily =
            this.jsonData.familyPortfolio?.totalCurrentValue || 0;
          this.familyPortfolioValue =
            this.jsonData.familyPortfolio?.dayChangeValue === null ||
            this.jsonData.familyPortfolio?.dayChangeValue === "NULL"
              ? ""
              : this.jsonData.familyPortfolio?.dayChangeValue;
          this.familyDayChangePer =
            this.jsonData.familyPortfolio.dayChangePercentage !== null
              ? this.jsonData.familyPortfolio.dayChangePercentage
              : "0.0";
        }
        this.updateDisplayValues();
      } catch (error) {
        console.error("Error processing data:", error.message);
      }
    },
    updateDisplayValues() {
  const own = this.jsonData.ownPortfolio || {};
  const family = this.jsonData.familyPortfolio || {};
  const activePortfolio = this.enabled ? family : own;
  if (this.holdingType === 'stocks' && (own.stockPortfolio || family.stockPortfolio)) {
    const stockValue = parseFloat(activePortfolio?.stockPortfolio?.totalStockValue || 0);
    const stockDayChange = parseFloat(activePortfolio?.stockPortfolio?.stockDayChangeValue || 0);
    const stockDayChangePer = stockValue > 0
      ? ((stockDayChange / stockValue) * 100).toFixed(2)
      : "0.00";

    this.amount = this.rupeeSymbol + " " + this.formatToIndianNumber(stockValue);
    this.value = stockDayChange !== 0 ? this.rupeeSymbol + " " + this.formatToIndianNumber(stockDayChange) : "";
    this.dayChangePer = stockDayChangePer + this.perSymbol;
  }
  else if (this.holdingType === 'mutualfunds') {
    const mfValue = parseFloat(activePortfolio?.totalCurrentValue || 0);
    const mfDayChange = parseFloat(activePortfolio?.dayChangeValue || 0);
    const mfDayChangePer = mfValue > 0
      ? ((mfDayChange / mfValue) * 100).toFixed(2)
      : "0.00";

    this.amount = this.rupeeSymbol + " " + this.formatToIndianNumber(mfValue);
    this.value = mfDayChange !== 0 ? this.rupeeSymbol + " " + this.formatToIndianNumber(mfDayChange) : "";
    this.dayChangePer = mfDayChangePer + this.perSymbol;
  }
  else if (this.holdingType === 'all') {
    const mutualFundValue = parseFloat(activePortfolio?.totalCurrentValue || 0) || 0;
    const mutualFundDayChange = parseFloat(activePortfolio?.dayChangeValue || 0) || 0;

    const stockValueRaw = parseFloat(activePortfolio?.stockPortfolio?.totalStockValue || 0);
    const stockDayChangeRaw = parseFloat(activePortfolio?.stockPortfolio?.stockDayChangeValue || 0);
    const hasStockHoldings = !isNaN(stockValueRaw) && stockValueRaw !== 0;

    const totalAllValue = mutualFundValue + (hasStockHoldings ? stockValueRaw : 0);
    const allDayChange =
      mutualFundDayChange + (hasStockHoldings && !isNaN(stockDayChangeRaw) ? stockDayChangeRaw : 0);

    const totalAllDayChangePer = totalAllValue > 0
      ? ((allDayChange / totalAllValue) * 100).toFixed(2)
      : "0.00";

    this.amount = this.rupeeSymbol + " " + this.formatToIndianNumber(totalAllValue);
    this.value = allDayChange !== 0 ? this.rupeeSymbol + " " + this.formatToIndianNumber(allDayChange) : "";
    this.dayChangePer = totalAllDayChangePer + this.perSymbol;
  }

  else {
    this.amount = this.rupeeSymbol + " " + this.formatToIndianNumber(activePortfolio?.totalCurrentValue || 0);
    this.value = activePortfolio?.dayChangeValue ? this.rupeeSymbol + " " + this.formatToIndianNumber(activePortfolio.dayChangeValue) : "";
    this.dayChangePer = (activePortfolio?.dayChangePercentage || "0.00") + this.perSymbol;
  }
},
    togglePortfolio() {
      this.enabled = !this.enabled;
      const newType = this.enabled ? "family" : "own";
      this.$store.commit("SETPORTFOLIOTYPE", newType);
      if (this.enabled) {
        this.portfolioTitle = "My family's portfolio";
        this.portfolioSubtitle = "";
        this.portfolioImage = this.familyfolioIcon;
      } else {
        this.portfolioTitle = "My portfolio";
        this.portfolioSubtitle = "Family portfolio";
        this.portfolioImage = this.portfolioIcon;
      }
      this.updateDisplayValues();
    },
  },
  watch: {
    myPortfolio: {
      handler(userValue) {
        this.processPRPData(userValue);
      },
      immediate: true,
    },
    "$store.getters.portfolioType": function (newType) {
      this.enabled = newType === "family";  
    },
    holdingType() {
      this.updateDisplayValues();
    },
  },
};
</script>

<style scoped>
.portfolio-switch {
  font-size: 10px;
  position: relative;
  left: -1px;
  top: 5px;
  font-family: rubik;
}

.portfolio-image {
  height: 21px;
}

.portfolio-switch-image {
  width: 30px;
}

.btn-custom {
  background-color: #01a2d9;
  border-color: #01a2d9;
  color: white;
}

.btn-custom:hover {
  background-color: #01a2d9;
  border-color: #01a2d9;
  color: white;
}

.dashboard-oneday {
  line-height: 32px;
  margin-top: -2px;
}

.row {
  margin-top: 10px;
}

.dashboard-heading {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  color: #012e40;
}
.dashboard-align {
  box-sizing: border-box;
  background: linear-gradient(180deg, #f6fdff 0%, #e2f9ff 100%);
  backdrop-filter: blur(5px);
  border-radius: 5px;
  padding: 6px 12px;
}

.positive {
  color: green;
}

.portfolio-link {
  transition: color 0.2s ease;
  color: #00a3d9; 
  cursor: pointer; 
  text-decoration: underline !important;
}



.negative {
  color: red;
}


</style>
